import * as React from 'react';
import { Icon } from '../Icon';
import { SIZE_12 } from '../../constants/sizes';
import { Link } from '../Link';
import { TextAndIcon } from '../TextAndIcon';
import { Container } from '../Container';
import * as styles from './SalesLeader.css';

export interface ISalesLeaderProps {
  salesLeaderFullUrl: string;
}

export function  SalesLeader(props: ISalesLeaderProps) {
  const { salesLeaderFullUrl } = props;

  return (
    <Container
      padding={`0 ${SIZE_12} 0 0`}
      display="inline-block"
      dataMark="SalesLeader"
    >
      <Link
        url={salesLeaderFullUrl}
        target="blank"
        linkStyle={styles['sales_leader']}
      >
        <>
          <TextAndIcon
            iconType="leader"
            reverse
            color="orange"
            iconColor="orange"
            iconColorHovered="orange"
            colorHovered="orange"
            fontWeight="bold"
            alignItems="baseline"
            offset={4}
            fontSize={12}
            iconSize={12}
          >
            Лидер продаж
          </TextAndIcon>
          <div className={styles['sales_leader-arrow']}>
            <Icon
              type="arrowRight"
              display="block"
            />
          </div>
        </>
      </Link>
    </Container>
  );
}
